import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight, Home } from "lucide-react";

interface ApplicationSuccessModalProps {
  isOpen: boolean;
  applicationId: string;
  jobTitle: string;
  email: string;
  onSubmitAnother: () => void;
}

const ApplicationSuccessModal = ({
  isOpen,
  applicationId,
  jobTitle,
  email,
  onSubmitAnother,
}: ApplicationSuccessModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 text-center"
          >
            {/* Success Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", delay: 0.2 }}
              className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center"
            >
              <CheckCircle className="w-10 h-10 text-white" />
            </motion.div>

            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Application Submitted!
            </h2>
            <p className="text-gray-600 mb-6">
              Thank you for applying for the{" "}
              <span className="font-medium">{jobTitle}</span> position.
            </p>

            {/* Application Details */}
            {/* <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Application ID</span>
                  <span className="font-mono font-medium text-[#8B52FF]">
                    {applicationId}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Confirmation sent to</span>
                  <span className="font-medium text-gray-900">{email}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Expected response</span>
                  <span className="font-medium text-gray-900">
                    3-5 business days
                  </span>
                </div>
              </div>
            </div> */}

            {/* What's Next */}
            <div className="bg-gradient-to-br from-[#8B52FF]/5 to-[#E05A6A]/5 rounded-xl p-4 mb-6 text-left">
              <h4 className="font-medium text-gray-900 mb-2">What's Next?</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                  Check your email for confirmation
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                  Our team will review your application
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                  If selected, you'll receive next steps via email
                </li>
              </ul>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/careers"
                className="flex-1 px-6 py-3 rounded-xl border border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition-colors text-center flex items-center justify-center gap-2"
              >
                <ArrowRight className="w-4 h-4" />
                More Jobs
              </Link>
              <Link
                to="/"
                className="flex-1 px-6 py-3 rounded-xl bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold hover:shadow-lg transition-all text-center flex items-center justify-center gap-2"
              >
                <Home className="w-4 h-4" />
                Back to Home
              </Link>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ApplicationSuccessModal;
